// Analytics tracking helpers
export const trackUserManagement = (action, count = 1) => {
    try {
      const llup = JSON.parse(localStorage.getItem('LLUP') || '{}');
      const oidcKey = Object.keys(localStorage).find(key => key.startsWith('oidc.user:'));
      const oidcData = oidcKey ? JSON.parse(localStorage.getItem(oidcKey) || '{}') : {};
      
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'user_management',
        'action': action, // 'add_user' or 'remove_user'
        'affected': count, // number of users affected
        'org_hash': llup.o,
        'user_id': oidcData.profile?.sub
      });
    } catch(e) {
      console.error('GTM tracking error:', e);
    }
  };
  
  // Track page views (for React Router navigation)
  export const trackPageView = (path) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'pageview',
      'page_path': path
    });
  };

  // New function for job removals
export const trackJobManagement = (action, count = 1) => {
    try {
      const llup = JSON.parse(localStorage.getItem('LLUP') || '{}');
      const oidcKey = Object.keys(localStorage).find(key => key.startsWith('oidc.user:'));
      const oidcData = oidcKey ? JSON.parse(localStorage.getItem(oidcKey) || '{}') : {};
      
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'job_management',
        'action': action,
        'affected': count,
        'org_hash': llup.o,
        'user_id': oidcData.profile?.sub
      });
    } catch(e) {
      console.error('GTM tracking error:', e);
    }
  };


  export const trackOnboarding = (action, step = null, stepNumber = null) => {
    try {
      const llup = JSON.parse(localStorage.getItem('LLUP') || '{}');
      const oidcKey = Object.keys(localStorage).find(key => key.startsWith('oidc.user:'));
      const oidcData = oidcKey ? JSON.parse(localStorage.getItem(oidcKey) || '{}') : {};
      
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'onboarding',
        'action': action,           // 'started', 'completed', 'skipped', 'milestone_reached'
        'step': step,               // 'welcome', 'first_domain', 'user_management', etc.
        'step_number': stepNumber,  // Actual step number (1-33)
        'org_hash': llup.o,
        'user_id': oidcData.profile?.sub
      });
    } catch(e) {
      console.error('GTM tracking error:', e);
    }
  };